import React, { useCallback, useState } from "react";
import { Pressable, StyleSheet, Text } from "react-native";

function SkipLink() {
  const [isFocused, setIsFocused] = useState(false);

  const focusMainContent = useCallback(() => {
    const target = document.getElementById("main-content");
    if (target) {
      if (!target.hasAttribute("tabindex")) {
        target.setAttribute("tabindex", "-1");
      }
      target.focus();
    }
  }, []);

  return (
    <Pressable
      role="link"
      aria-label="Skip to main content"
      accessibilityRole="link"
      accessibilityLabel="Skip to main content"
      onPress={focusMainContent}
      // @ts-expect-error — onKeyDown is a web-only prop not in RN types; needed because Pressable role="link" misses Enter
      onKeyDown={(e: React.KeyboardEvent) => {
        if (e.key === "Enter") {
          e.preventDefault();
          focusMainContent();
        }
      }}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      style={[styles.base, isFocused ? styles.visible : styles.hidden]}>
      <Text style={styles.text}>Skip to main content</Text>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  base: {
    position: "absolute",
    zIndex: 9999,
  },
  hidden: {
    top: -1000,
    left: -1000,
  },
  visible: {
    top: 8,
    left: 8,
    backgroundColor: "#fff",
    padding: 8,
    borderRadius: 4,
  },
  text: {
    color: "#000",
  },
});

export default SkipLink;
